import { type ComponentProps } from 'react';

import { SubmitRequestDialog } from 'components/requests/dialogs/SubmitRequestDialog';

type SubmitNewRequestDialogProps = Pick<
    ComponentProps<typeof SubmitRequestDialog>,
    'isOpen' | 'onClose'
>;

export const SubmitNewRequestDialog = ({ isOpen, onClose }: SubmitNewRequestDialogProps) => (
    <SubmitRequestDialog title="Submit Request" isOpen={isOpen} onClose={onClose} />
);
